module.exports = __webpack_public_path__ + "img/APP_about_banner@3x.a15fdd6d.png";